import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  AcceptMatchInvite,
  CancelMatchInvite,
  FetchContacts,
  FetchPrimeContacts,
  RejectMatchInvite,
  SendMatchInvite,
} from "../../Store/Actions/matchesActionCreator";
import { showMessage } from "../../Utils/helper";
import InviteSharedInfoModal from "../Modals/ModalContexts/InviteSharedInfoModal";
import InboxCard from "./InboxCard";
import { useConfirm } from "../ConfirmationModal";

function InboxUserCard({ user, ...props }) {
  const [loading, setloading] = useState(false);
  const [contactResp, setContactResp] = useState(null);
  const [isInviteSharedModalOpen, toggleInviteSharedModal] = useState(false);

  const ConfirmationModal = useConfirm();
  const SendInvitation = () => {
    if (!!props?.data?.id) {
      setloading(true);
      props?.dispatchSendMatchInvite(
        props?.data?.id,
        (resp) => {
          if (resp?.status) {
            showMessage(
              resp?.result ?? "Invitation sent successfully",
              "success"
            );
          } else {
            showMessage(resp?.result ?? "Failed to Express Interest", "error");
          }
          setloading(false);
          props?.setCategoryType("");
        },
        (err) => {
          showMessage("Failed to Express Interest", "error");
          setloading(false);
        }
      );
    }
  };
  const CancelInvite = () => {
    if (!!props?.data?.id) {
      ConfirmationModal({
        title: "Are you sure?",
        description: "You want to cancel this invite.",
        confirmationText: "Yes",
        confirmationButtonProps: {
          variant: "contained",
          style: {
            // backgroundColor: '',
            color: "white",
          },
        },
        cancellationButtonProps: {
          style: {
            // backgroundColor: '',
            color: "red",
          },
        },
        cancellationText: "No",
      }).then(() => {
        setloading(true);
        props?.dispatchCancelMatchInvite(
          props?.data?.id,
          (resp) => {
            if (resp?.status) {
              // showMessage(resp?.result, "success");
            } else {
              showMessage(resp?.result, "error");
            }
            setloading(false);
            props?.setCategoryType(""); //This is done to refresh the page once invite is rejected/Accepted
          },
          (err) => {
            setloading(true);
            showMessage("Something went wrong!", "error");
          }
        );
      });
    }
  };

  const fetchPrimeContacts = () => {
    if (!!props?.data?.id) {
      setloading(true);
      props?.dispatchFetchPrimeContacts(
        props?.data?.id,
        (resp) => {
          if (resp?.status) {
            // showMessage("success", "success");
            setContactResp(resp?.result);
            toggleInviteSharedModal(true);
          } else {
            showMessage(resp?.result, "error");
          }
          setloading(false);
        },
        (err) => {
          setloading(true);
          showMessage("Something went wrong!", "error");
        }
      );
    }
  };

  const fetchContacts = () => {
    if (!!props?.data?.id) {
      setloading(true);
      props?.dispatchFetchContacts(
        props?.data?.id,
        (resp) => {
          if (resp?.status) {
            // showMessage("success", "success");
            setContactResp(resp?.result);
            toggleInviteSharedModal(true);
          } else {
            showMessage(resp?.result, "error");
          }
          setloading(false);
        },
        (err) => {
          setloading(true);
          showMessage("Something went wrong!", "error");
        }
      );
    }
  };
  const AcceptInvite = () => {
    if (!!props?.data?.id) {
      setloading(true);
      props?.dispatchAcceptMatchInvite(
        props?.data?.id,
        (resp) => {
          if (resp?.status) {
            showMessage(resp?.result, "success");
          } else {
            showMessage(resp?.result, "error");
          }
          setloading(false);
          props?.setCategoryType("");
        },
        (err) => {
          setloading(true);
          showMessage("Something went wrong!", "error");
        }
      );
    }
  };
  const RejectInvite = () => {
    if (!!props?.data?.id) {
      ConfirmationModal({
        title: "Are you sure?",
        description: "You want to decline this invite.",
        confirmationText: "Yes",
        confirmationButtonProps: {
          variant: "contained",
          style: {
            // backgroundColor: '',
            color: "white",
          },
        },
        cancellationButtonProps: {
          style: {
            // backgroundColor: '',
            color: "red",
          },
        },
        cancellationText: "No",
      }).then(() => {
        setloading(true);
        props?.dispatchRejectMatchInvite(
          props?.data?.id,
          (resp) => {
            if (resp?.status) {
              showMessage(resp?.result, "success");
            } else {
              showMessage(resp?.result, "error");
            }
            setloading(false);
            props?.setCategoryType("");
          },
          (err) => {
            setloading(true);
            showMessage("Something went wrong!", "error");
          }
        );
      });
    }
  };
  const newProps = {
    ...props,
    isInviteSharedModalOpen,
    toggleInviteSharedModal,
    contactResp,
    loading,
    CancelInvite,
    RejectInvite,
    AcceptInvite,
    fetchContacts,
    fetchPrimeContacts,
    SendInvitation,
    user,
  };
  return (
    <>
      <InboxCard {...newProps} />
      {!!isInviteSharedModalOpen && (
        <InviteSharedInfoModal
          open={isInviteSharedModalOpen}
          data={contactResp}
          onClose={() => {
            toggleInviteSharedModal(false);
          }}
          next={() => {
            toggleInviteSharedModal(false);
          }}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchCancelMatchInvite: (id, onSuccess, onError) =>
    dispatch(CancelMatchInvite(id, onSuccess, onError)),
  dispatchFetchContacts: (id, onSuccess, onError) =>
    dispatch(FetchContacts(id, onSuccess, onError)),
  dispatchAcceptMatchInvite: (id, onSuccess, onError) =>
    dispatch(AcceptMatchInvite(id, onSuccess, onError)),
  dispatchRejectMatchInvite: (id, onSuccess, onError) =>
    dispatch(RejectMatchInvite(id, onSuccess, onError)),
  dispatchFetchPrimeContacts: (id, onSuccess, onError) =>
    dispatch(FetchPrimeContacts(id, onSuccess, onError)),
  dispatchSendMatchInvite: (id, onSuccess, onError) =>
    dispatch(SendMatchInvite(id, onSuccess, onError)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InboxUserCard));
